import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";

export const runData: (data: any) => Promise<any> = async (data) => {
  const ednString = toEDNStringFromSimpleObject(data as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.Run "omega/query-omega/public/api/run")
    (= Input ${ednString})
    (Qo.Public.Api.Run/run-data Input Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
